import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const user_key = 'user'
const store = new Vuex.Store({
    state: {
        userInfo: {
            token: '',
            area: '',
            mobile: '',
            code: '',
            inviteCode: '',
            people: 0,

            cardId: 0,
            isCard: 0,
            inviteCount: 0,
            isFbLike: 0,
            isJoinGuild: 0,
            isReservation: 1,
            isShare: 0,
            isStore: 0
        },
        count: 1
    },
    mutations: {
        initStore(state) {
            let a = JSON.parse(localStorage.getItem(user_key))
            // console.log('init->', a)
            if (a) {
                // console.log('init2->', a)
                this.commit('loginLocal', a)
            }
        },
        loginLocal(state, payload) {
            // console.log('loginLocal->', payload)
            state.userInfo = Object.assign(state.userInfo, payload)
            localStorage.setItem(user_key, JSON.stringify(state.userInfo));
        },
        logout(state) {
            state.userInfo = {
                token: '',
                mobile: ''
            }
            localStorage.setItem(user_key, null);
        }
    }
})
export default store